import { Button } from '@/components/ui/button'

interface AuthPrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	label: string
	isLoading?: boolean
}

export function AuthPrimaryButton({ label, isLoading = false, disabled, type = 'button', ...props }: AuthPrimaryButtonProps) {
	return (
		<Button type={type} disabled={disabled || isLoading} variant='primary' {...props}>
			<span>{label}</span>
		</Button>
	)
}
